import { STATIC_URL } from 'constants/data'

const imgInfo = {
  mobile: {
    src: `${STATIC_URL}/intro-alt/necessary/aibolit-info-mob.png`,
    width: 360,
    height: 301,
    alt: 'AiBolit',
  },
  desktop: {
    src: `${STATIC_URL}/intro-alt/necessary/aibolit-info.png`,
    width: 545,
    height: 585,
    alt: 'AiBolit',
  },
}

const logoAIBolit = {
  src: `${STATIC_URL}/intro-alt/necessary/aibolit-logo.png`,
  width: 62,
  height: 66,
  alt: 'logo ai bolit',
}

const iconData = {
  src: `${STATIC_URL}/icons/icon_tick_blue.png`,
  width: 22,
  height: 22,
  alt: 'arrow',
}

const points = [
  '<span>Точные ответы на ваши клинические вопросы за&nbsp;считанные секунды </span> напрямую из актуальных клинических рекомендаций',
  '<span>«Второе мнение»</span> при работе с нестандартными клиническими ситуациями',
  '<span>Информация, адаптированная под пациента </span> с учетом возраста, сопутствующих заболеваний и других факторов',
]

export { imgInfo, logoAIBolit, points, iconData }
